export const initFlash = () => {
  window.setTimeout(() => $("#flash .notice").fadeOut("slow"), 2000)
  window.setTimeout(() => $("#flash .alert").fadeOut("slow"), 2000)
}
